import { atom } from "recoil";

export const tgBotsStore = atom({
	key: "tgBotsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentSearch: "",
		sorting: {
			sortingColumn: {
				order: "DESC",
				column: "id",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
